import script from "./result.vue?vue&type=script&lang=ts&setup=true"
export * from "./result.vue?vue&type=script&lang=ts&setup=true"

import "./result.vue?vue&type=style&index=0&id=591ac594&scoped=true&lang=less"

import exportComponent from "D:\\客户端h5\\operationmanual\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-591ac594"]])

export default __exports__